<template>
  <div class="login">
    <div class="login-head">
      <img src="../assets/image/logo_login-hgd.png" style="margin-right:60px;" />
      <img src="../assets/image/hgd-txt.png" style="height:5vh;" />
      <!-- <span style="font-size:60px;color:#fff;font-weight: 600;">合肥工业大学项目管理平台</span> -->
    </div>
    <!-- <p>智慧建筑管理系统</p> -->
    <div class="login-frm">
      <!-- <div class="login-QR" @click="codeShow = !codeShow"></div> -->
      <h1 class="title">合肥工业大学项目管理平台</h1>
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" label-width="0px" >
        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input placeholder="请输入您的账号" prefix-icon="el-icon-user-solid" style="color:#f00" v-model="loginForm.username"></el-input>
          <!-- <span class="el-frm-name">账号：</span>
          <el-input auto-complete="off" style="color:#f00" v-model="loginForm.username"></el-input> -->
        </el-form-item>
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input placeholder="请输入您的密码" type="password" prefix-icon="el-icon-lock" style="color:#f00" v-model="loginForm.password"></el-input>
          <!-- <span class="el-frm-psw" >密码：</span>
          <el-input auto-complete="off" type="password" v-model="loginForm.password"></el-input> -->
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item>
          <el-button round type="primary" @click="login('loginFormRef')">登录</el-button>
        </el-form-item>
      </el-form>
      <el-collapse-transition>
        <div v-show="codeShow" class="qrCode-box">
          <img :src="qrCode" />
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>
<script>
import myHttp from '../untils/port';
import util from '../untils/util';
export default {
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: [
          { require: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [
          { require: true, message: "请输入登录密码", trigger: "blur" }
        ]
      },
      qrCode:'',
      codeShow:false
    }
  },
  methods: {
    login(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
          if (valid) {
             myHttp.login({
                username:that.loginForm.username,
                password:that.loginForm.password
            }).then(function(resp){
                if(resp.data.code=="200"){
                    util.session.set('token',resp.data.data.token.accessToken);
                    util.session.set('user',resp.data.data.user);
                    util.session.set('type','1');
                    var roleList = resp.data.data.relations||[]
                    var list = []
                    for(var i=0;i<roleList.length;i++){
                        if(roleList[i].userType=='5'){
                            list.unshift(roleList[i])
                        }else if(roleList[i].userType!='2'&&roleList[i].userType!='1'&&roleList[i].userType!='6'){
                            list.push(roleList[i])
                        }
                    }
                    util.session.set('role',list);
                    that.$store.commit("getToken");
                    that.$store.commit("setUser");
                    that.$store.commit("getRole");
                    if(that.filterPort(list,5)){
                        that.$router.push({ path: '/comHome' })
                    }else if(that.filterPort(list,4)){
                        that.$router.push({ path: '/homeAll' })
                    }else if(that.filterPort(list,3)){
                        that.$router.push({ path: '/buildHome' })
                    }
                  // untils.session.set('token',resp.data.data.token.accessToken);
                  // untils.session.set('user',resp.data.data.user);
                  // untils.session.set('role',resp.data.data.relations);
                  // untils.session.set('type','1');
                  // that.$store.commit("getToken");
                  // that.$store.commit("setUser");
                  // that.$store.commit("getRole");
                  // that.$store.commit("setType");
                  // var roleList = resp.data.data.relations;
                  // if(roleList.length>0){
                  //   if(roleList[0].userType=='1'){
                  //     that.$router.push({ name: 'userMan' })
                  //   }else if(roleList[0].userType=='3'){
                  //     that.$router.push({ name: 'homeEnt' })
                  //   }else if(roleList[0].userType=='4'){
                  //     that.$router.push({ name: 'homeAll' })
                  //   }else if(roleList[0].userType=='2'){
                  //     that.$router.push({ path: '/supProjects' })
                  //   }else{
                  //     that.$router.push({ path: '/' })
                  //   }
                  // }else{
                  //   that.$router.push({ path: '/' })
                  // }
                }else{
                  that.$message.error(resp.data.msg);
                }
            },function(){});
          }
      });
    },
    showCode(){

    },

    //判断有没有端
    filterPort(list,port){
        var result = false
        for(var i=0;i<list.length;i++){
            if(list[i].userType==port){
                result = true
            }
        }
        return result
    },
  }
}
</script>
<style scoped>
  .login{
    width: 100%;
    min-width: 1080px;
    height: 100vh;
    box-sizing: border-box;
    background: url(../assets/image/4.png) 100% 100%;
    position: relative;
  }
  .login p {
    position: absolute;
    left: 37.8%;
    top: 18%;
    font-size: 38px;
    font-weight: bold;
    color: #151516;
  }
  .login-head{
    position: absolute;
    width: 100%;
    top: 10px;
    left: 0;
    height: 140px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 20px;
  }

 /*----------- 主体 -----------*/

  .login-frm {
    position: absolute;
    top: 18%;
    left: 55%;
    width: 33vw;
    height: 52vh;
    color: #151516;
    background-color: rgba(255, 255, 255, 1);
    box-shadow:0px 3px 6px rgba(0,0,0,0.16);
    border-radius: 20px;
  }
  .login-frm .title{
    width: 100%;
    height: 15vh;
    position: relative;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-content: center;
    align-items: center;
    font-size: 40px;
    font-family: 'FZLTTHK--GBK1-0';
    color: #358ADA;
  }
  /* .login-img {
    width: 56%;
    height: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .login-img img {
    width: 90%;
  } */
  .el-form {
    position: relative;
    height: calc( 100% - 15vh );
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 4.5vw;
  }
  .el-form .el-frm-tit {
    font-size: 24px;
    text-align: center;
  }
  .el-form .el-form-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 6vh;
  }
  .el-form .el-form-item:nth-child(1) {
    /* margin-top: 50px; */
    border-bottom: 1px solid #D6D3D6;
  }
  .el-form .el-form-item:nth-child(2) {
    border-bottom: 1px solid #D6D3D6;
    margin-top: 3vh;
  }
  .el-form .el-form-item:nth-child(3) {
    border-bottom: none;
  }
  .el-form-item .el-input {
    width: 200px;
    margin-left: 10px;
  }
  .el-form-item >>> .el-input__inner {
    background-color: rgba(192, 221, 248, 0);
    border-radius: 0;
    border: none;
  }
  .el-button {
    width: 100%;
    height: 6vh;
    margin-top: 3vh;
    font-weight: bold;
    border: none;
    font-size: 1.2vw;
    font-weight: 600;
    font-family: 'MicrosoftYaHei';
    border-radius: 3vh;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
  }
  .login-QR {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 10px;
    right: 20px;
    background: url(../assets/image/login-QR.png) no-repeat -1px -1px;
    border: 1px dashed #707070; 
    border-radius: 5px;
    z-index: 100;
  }
  .qrCode-box{
    position:absolute;
    top:0px;
    left:0px;
    max-height:100%;
    width:56%;
    background:rgba(255, 255, 255, 0.8);
    display:flex;
    justify-content: center;
    align-items: center;
    padding:80px;
    box-sizing: border-box;
  }
  .qrCode-box img{
    position: relative;
    width: 200px;
    height: 200px;
  }
</style>
<style>
  .login-frm .el-form-item__content{
    width: 100%;
    height: 100%;
  }
  .login-frm .el-form-item .el-input{
    width: 100%;
    max-width: none;
    height: 100%;
    margin-left:0;
  }
  .login-frm .el-form-item .el-input__inner{
    height: 100%;
    padding-left: 2vw;
    font-size: 1.2vw;
  }
  .login-frm .el-input__icon{
    color: #9B989D;
    font-size: 1.2vw;
    /* padding-top: 0.8vh; */
  }
  .login-frm input:-webkit-autofill,
  .login-frm input:-webkit-autofill:hover,
  .login-frm input:-webkit-autofill:focus {
    /*背景颜色*/
    box-shadow:0 0 0 60px #fff inset; 
    /*字的颜色*/
    /* -webkit-text-fill-color: #878787; */
  }
</style>